<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WrjsPJ/tc-custom/9781572848207.jpg?1729379416930" alt="This image is the cover for the book New Filipino Kitchen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Filipino Kitchen
      </h1>
      <p class="bookDescription body article font2">
        <b>“An engrossing, page-turner of a cookbook. If you can even call it a cookbook—it’s more of a short story collection with delicious, addictive recipes.” —Brian McGinn, Emmy-nominated director and executive producer, <i>Chef’s Table</i></b><br/><br/><b>Named a top cookbook of 2018 by the <i>San Francisco Chronicle</i> and Epicurious</b><br/><br/>You may not realize that Filipino Americans are the second-largest Asian American group living in the United States, especially when you compare the number of, say, Japanese, Thai, and Korean restaurants to Filipino ones. There’s a lot of speculation about why Filipino food hasn’t taken off the way other Asian cuisines have, but one thing’s for sure: there’s something for everyone here.<br/><br/><i>The New Filipino Kitchen</i> collects thirty recipes and stories from expat Filipinos, all of whom have taken their favorite dishes with them, preserving their food memories and, if necessary, tweaking their recipes to work in a new environment or, in the case of some chefs, a more modern context. With contributions from White House executive chef Cristeta Comerford, silver Bocuse d’Or winner Christian André Pettersen, five-time Palanca Award winner and poet Francis Macansantos, and the “Food Buddha” Rodelio Aglibot, this is a multifaceted, nuanced introduction to the world of Filipino food and food culture.<br/><br/><b>“Contributors’ entrancing essays about work, life, and love of their heritage are not to be missed . . . A gentle, inspiring, and exciting introduction to a savory world still new to many U.S. readers.” —<i>Booklist</i>, starred review</b><br/><br/><b>“Engrossing stories and delicious recipes.” —<i>Foodista</i></b><br/><br/><b>“A wonderful multilayered answer to the question ‘What is Filipino food?’ and an invitation to everyone to get cooking.” —Naomi Duguid, author of James Beard Award–winning <i>Taste of Persia</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Chio-Lauri, Rowena Dumlao-Giardina
      </h2>
      
      <p class="authorDescription body article">Jacqueline Chio-Lauri has more than eight years’ experience in the food industry opening and managing restaurants at deluxe hotels, such as Shangri-La and Sheraton. While working in Dubai, she was one of the five young women professionals featured in <I>Emirates Woman</I> magazine’s special report “Why the Future Is Female.”<BR><BR> Her writing has appeared in anthologies and compilations such as <I>Chicken Soup for the Soul: Find Your Inner Strength</I> and <I>Tales of Our Lives: Fork in the Road</I>. Her website, My Food Beginnings, was created to fire up an appetite for Filipino food worldwide. <I>The Migrant Filipino Kitchen</I>, her first book, won the Sunshot Prose 2017 Finalist Prize before it was published. She currently lives in Norway, her sixth country of residence.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Surrey Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5cc16d06